// Sandbox demo data (Constitución: Training Sandbox, datos ficticios).
import type { VaultDocument, TaxReturn } from '@/types/domain';

export const KPIS = [
  { key: 'activeClients', value: 248, delta: '+12%', tone: 'primary' as const },
  { key: 'documents', value: 3142, delta: '+5%', tone: 'cyan' as const },
  { key: 'pendingReturns', value: 37, delta: '-8%', tone: 'gold' as const },
  { key: 'expiringSoon', value: 14, delta: '+3', tone: 'warning' as const },
];

export const EXPIRING_DOCUMENTS: Pick<VaultDocument, 'id' | 'title' | 'type' | 'expiryDate' | 'status'>[] = [
  { id: '1', title: "Driver's License — M. Santos", type: 'license', expiryDate: '2026-07-02', status: 'expiring_soon' },
  { id: '2', title: 'Passport — A. Rivera', type: 'passport', expiryDate: '2026-07-09', status: 'expiring_soon' },
  { id: '3', title: 'Residence Card — L. Gómez', type: 'residence', expiryDate: '2026-06-25', status: 'expiring_soon' },
  { id: '4', title: 'W-2 2025 — Núñez LLC', type: 'w2', expiryDate: '2026-06-21', status: 'expired' },
];

export const RECENT_RETURNS: (TaxReturn & { client: string })[] = [
  { id: 'r1', clientId: 'c1', client: 'María Santos', year: 2025, season: 'Spring', status: 'signed', createdAt: '', updatedAt: '' },
  { id: 'r2', clientId: 'c2', client: 'Andrés Rivera', year: 2025, season: 'Spring', status: 'in_review', createdAt: '', updatedAt: '' },
  { id: 'r3', clientId: 'c3', client: 'Lucía Gómez', year: 2025, season: 'Spring', status: 'received', createdAt: '', updatedAt: '' },
  { id: 'r4', clientId: 'c4', client: 'Núñez LLC', year: 2025, season: 'Spring', status: 'delivered', createdAt: '', updatedAt: '' },
];
